import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE from "./config";

function AdminArticles() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ title: "", url: "", date: "", cover: "" });
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("adminToken");
    console.log("AdminArticles: token =", token); // 👈 加这行
    if (!token) {
      console.log("AdminArticles: 无 token，跳回登录");
      navigate("/admin/login");
      return;
    }

    fetch(`${API_BASE}/api/admin/articles`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => {
        console.log("AdminArticles: 验证 token 响应状态", res.status); // 👈 加这行
        if (!res.ok) throw new Error("Invalid token");
        return res.json();
      })
      .then((data) => {
        console.log("AdminArticles: 获取到文章数据", data);
        setArticles(data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("AdminArticles: token 验证失败", err); // 👈 加这行
        localStorage.removeItem("adminToken");
        navigate("/admin/login");
      });
  }, [navigate]);

  const handleAdd = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("adminToken");
    const res = await fetch(`${API_BASE}/api/admin/articles`, {
      // 👈 改这里
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(form),
    });
    const newArticle = await res.json();
    setArticles([newArticle, ...articles]);
    setForm({ title: "", url: "", date: "", cover: "" });
  };

  const handleDelete = async (id) => {
    const token = localStorage.getItem("adminToken");
    await fetch(`${API_BASE}/api/admin/articles/${id}`, {
      // 👈 改这里
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    setArticles(articles.filter((a) => a.id !== id));
  };
  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    navigate("/admin/login");
  };

  return (
    <div style={{ maxWidth: "800px", margin: "2rem auto", padding: "1rem" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2>文章管理</h2>
        <button onClick={handleLogout}>退出登录</button>
      </div>

      {/* 添加文章表单 */}
      <form onSubmit={handleAdd} style={{ marginBottom: "2rem" }}>
        <input
          type="text"
          placeholder="标题"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          required
          style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
        />
        <input
          type="text"
          placeholder="链接"
          value={form.url}
          onChange={(e) => setForm({ ...form, url: e.target.value })}
          required
          style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
        />
        <input
          type="text"
          placeholder="日期（YYYY-MM-DD）"
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
          style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
        />
        <input
          type="text"
          placeholder="封面图URL（可选）"
          value={form.cover}
          onChange={(e) => setForm({ ...form, cover: e.target.value })}
          style={{ width: "100%", marginBottom: "0.5rem", padding: "0.5rem" }}
        />
        <button type="submit">发布文章</button>
      </form>

      {/* 文章列表 */}
      {loading ? (
        <p>加载中...</p>
      ) : (
        <ul style={{ listStyle: "none", padding: 0 }}>
          {articles.map((article) => (
            <li
              key={article.id}
              style={{
                marginBottom: "1rem",
                borderBottom: "1px solid #ccc",
                paddingBottom: "1rem",
              }}
            >
              {article.cover && (
                <img
                  src={article.cover}
                  alt=""
                  style={{ width: "100px", height: "auto" }}
                />
              )}
              <h3>{article.title}</h3>
              <p>{article.date}</p>
              <a href={article.url} target="_blank" rel="noreferrer">
                {article.url}
              </a>
              <button
                onClick={() => handleDelete(article.id)}
                style={{ marginLeft: "1rem" }}
              >
                删除
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AdminArticles;
